/* Draws the "Ifti effect" chart (snippets/hc-ifti-graph.liquid) as the visitor scrolls:
   the flat line runs in from the left, then the line climbs once the work starts.
   Scroll position drives the drawing, so scrolling back up rewinds it. */
(function () {
  var el = document.querySelector('[data-hc-live-graph]');
  if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var base = el.querySelector('[data-hc-clip="base"]'), rise = el.querySelector('[data-hc-clip="rise"]');
  var shown = 0, target = 0, raf = 0, visible = false;
  el.classList.add('is-live');

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function measure() {
    var r = el.getBoundingClientRect(), vh = window.innerHeight, y = window.scrollY, top = r.top + y;
    // 0 when the chart enters at the bottom, 1 when its middle reaches 55% of the screen,
    // or earlier if the page ends first (on phones the chart sits right above the footer).
    var start = top - vh, end = Math.min(top + r.height / 2 - vh * .55, document.documentElement.scrollHeight - vh - 24);
    target = end > start ? clamp((y - start) / (end - start)) : 1;
  }
  function paint() {
    shown += (target - shown) * .12;
    if (Math.abs(target - shown) < .001) shown = target;
    var b = clamp(shown / .5), u = clamp((shown - .5) / .45);
    base.setAttribute('width', (b * 1300).toFixed(1));
    rise.setAttribute('width', (u * 560).toFixed(1));
    el.classList.toggle('is-up', u > .2);
    el.classList.toggle('is-done', u >= .99);
    raf = shown !== target || visible ? requestAnimationFrame(loop) : 0;
  }
  function loop() { if (visible) measure(); paint(); }
  function kick() { if (!raf) raf = requestAnimationFrame(loop); }

  measure(); shown = target; paint();
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) kick(); }).observe(el);
  } else { visible = true; kick(); }
  window.addEventListener('resize', function () { measure(); kick(); }, { passive: true });
})();
